import { Observable, of } from 'rxjs';
import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { NaxosNotificationService } from "../services";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate() {
    if (!this.authService.loggedIn) {
      return this.router.parseUrl('/public');
    } else {
      return true;
    }
  }
}
